import { render, staticRenderFns } from "./ConsumersSmsPromotion.vue?vue&type=template&id=63fecbf5"
import script from "./ConsumersSmsPromotion.vue?vue&type=script&lang=js"
export * from "./ConsumersSmsPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports